import React from 'react';

function Contactpage() {
    return (
        <div>
            <h1>
                Blance Contact
            </h1>
        </div>
    )
}

export default Contactpage;